<template>
    <ExitDeclarationCard
        ref="exitDeclarationCard"
        :exit-declaration="exitDeclaration"
        :exit-declaration-statuses="exitDeclarationStatuses"
        :currencies="currencies"
        :warehouses="warehouses"
        :selected-warehouse="selectedWarehouse"
        v-model:selected-currency="selectedCurrency"
        v-model:selected-status="selectedStatus"
        v-model:selected-order="selectedOrder"
        @update:currency-rate="exitDeclaration.currency_rate = $event"
        @edit="editExitDeclaration"
        @delete="deleteExitDeclaration"
    />
    <ProductItemsCard
        v-if="exitDeclaration"
        :exit-declaration="exitDeclaration"
        :can-modify="canModify"
        :currency-uuid="selectedCurrency?.uuid ?? ''"
        :currency-rate="selectedCurrency?.rate ?? ''"
        :main-currency="mainCurrency"
        :currencies="currencies"
    />
    <DocumentCard
        v-if="exitDeclaration"
        :exit-declaration="exitDeclaration"
        @document-created="documentCreated"
    />
</template>

<script>
import ExitDeclarationCard from './cards/ExitDeclarationCard.vue';
import ProductItemsCard from './cards/ProductItemsCard.vue';
import DocumentCard from './cards/DocumentCard.vue';
import { httpClient } from '../../../../services/HttpClient';
import MessageNotificator from '../../../../services/MessageNotificator';
export default {
    name: 'EditExitDeclarationPage',
    components: {
        ExitDeclarationCard, ProductItemsCard, DocumentCard
    },
    data() {
        return {
            exitDeclaration: null,
            selectedCurrency: null,
            selectedStatus: null,
            exitDeclarationStatuses: [],
            currencies: [],
            selectedWarehouse: null,
            warehouses: [],
            selectedOrder: null
        }
    },
    methods: {
        async fetchExitDeclaration() {
            await httpClient.get(`/management/exit-declarations/${this.$route.params.exitDeclarationUuid}`).then(response => {
                this.exitDeclaration = response.data.data;
            })
        },
        async fetchCurrencies() {
            await httpClient.get('/list/currencies', { limit: 100 }).then((response) => {
                this.currencies = response.data.data
            })
        },
        async fetchExitDeclarationStatuses() {
            await httpClient.get('/management/exit-declaration-statuses', { limit: 100 }).then(response => {
                this.exitDeclarationStatuses = response.data.data
            })
        },
        async fetchWarehouses() {
            await httpClient.get('/management/warehouses', { limit: 100 }).then(response => {
                this.warehouses = response.data.data
            })
        },
        async fetchOrder() {
            await httpClient.get(`/projects/${this.$route.params.projectUuid}/crm/orders/${this.exitDeclaration.order_uuid}`).then(response => {
                this.selectedOrder = response.data.data
            })
        },
        async editExitDeclaration() {
            if (this.selectedStatus) {
                await httpClient.put(`/projects/${this.$route.params.projectUuid}/management/exit-declarations/${this.exitDeclaration.uuid}/update-status`, {
                    status_id: this.selectedStatus.id
                }).then(response => {
                    this.exitDeclaration.status = response.data.data.status;
                    new MessageNotificator().success(this.$t('alerts.success'));
                })
            }

            await httpClient.patch(`/projects/${this.$route.params.projectUuid}/management/exit-declarations/${this.exitDeclaration.uuid}`, {
                currency_uuid: this.selectedCurrency?.uuid ?? null,
                currency_rate: this.exitDeclaration.currency_rate,
                order_uuid: this.selectedOrder?.uuid ?? null
            })
        },
        documentCreated(document) {
            this.exitDeclaration.files = {
                ...(this.exitDeclaration.files ?? {}),
                [document.uuid]: { url: document.url }
            };
        },
        deleteExitDeclaration() {
            new MessageNotificator().confirm(
                this.$t('alerts.confirm_delete', { value: this.$t('labels.exit_declaration') }),
                () => {
                    httpClient.delete(`/management/exit-declarations/${this.exitDeclaration.uuid}`).then(() => {
                        this.$router.push({ name: 'IndexExitDeclarationPage' })
                    })
                }
            )
        },

    },
    computed: {
        mainCurrency() {
            return this.currencies.find(currency => currency.main === 1)
        },
        canModify() {
            if (!this.exitDeclaration) return true
            return this.exitDeclaration.status?.type === 'fail'
        }
    },
    async mounted() {
        await this.fetchExitDeclaration();
        await Promise.all([
            this.fetchCurrencies(),
            this.fetchExitDeclarationStatuses(),
            this.fetchWarehouses()
        ]);

        this.selectedCurrency = this.currencies.find(currency => currency.uuid === this.exitDeclaration.currency_uuid);
        this.selectedStatus = this.exitDeclarationStatuses.find(status => status.uuid === this.exitDeclaration.status?.uuid);
        this.selectedWarehouse = this.warehouses.find(warehouse => warehouse.id === this.exitDeclaration.warehouse_id);

        if (this.exitDeclaration.order_uuid) {
            await this.fetchOrder();
        }
    }
}
</script>
